// extracted by mini-css-extract-plugin
module.exports = {"externalLinkIcon":"s-module--externalLinkIcon--1OXEJ"};